import {
	CREATE_SIMULATE_EHR_REQUEST,
	CREATE_SIMULATE_EHR_SUCCESS,
	CREATE_SIMULATE_EHR_ERROR,
	CREATE_SIMULATE_EHR_RESET,
} from '../actions/createSimulateEhrAction';

const initialState = {
	apiState: '',
	data: null,
	error: null,
};

const createSimulateEhrReducer = (state = initialState, action) => {
	switch (action.type) {
		case CREATE_SIMULATE_EHR_REQUEST:
			return {
				...state,
				apiState: 'loading',
			};
		case CREATE_SIMULATE_EHR_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.payload,
				error: null,
			};
		case CREATE_SIMULATE_EHR_ERROR:
			return {
				...state,
				apiState: 'error',
				error: action.payload,
			};
		case CREATE_SIMULATE_EHR_RESET:
			return initialState;
		default:
			return state;
	}
};

export default createSimulateEhrReducer; 